import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { environment } from 'src/environments/environment';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(
    public router: Router,
    public logoutService: LogoutService,
    private auth: RxAuthService
  ) {}

  ngOnInit(): void {
    this.logout();
  }

  logout() {
    this.logoutService.logout().subscribe(
      () => {
        this.auth.clearAllStorages();
        // Successful logout logic here
        console.log('User logged out');
        window.location.href =  `${environment.wp.frontend_base}login`;
      },
      (error) => {
        // Handle any errors that may occur during logout
        console.error('Logout failed:', error);
      }
    );
  }
}
